import { createFileRoute } from '@tanstack/react-router'

import { ConfiguratorScope, PropertyType } from '@brickup/shared/enums'
import { PROPERTY_TYPE_LABELS } from '@brickup/shared/locales/de/enum-labels'
import { configuratorListFilters } from '@/components/Internal/ConfiguratorCMS/configurator-list-filters'
import { ConfiguratorScreen } from '@/components/Internal/ConfiguratorCMS/ConfiguratorScreen'
import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { Tabs } from '@/components/Internal/Tabs'

const SCOPE_LABELS = {
  CUSTOMER: 'Customer',
  PUBLIC: 'Public',
} as const satisfies Record<ConfiguratorScope, string>

/** One tab per tree: every scope holds one tree per property type. */
const TREE_TABS = Object.values(ConfiguratorScope).flatMap(scope =>
  [PropertyType.HOUSE, PropertyType.APARTMENT].map(propertyType => ({
    id: `${scope}:${propertyType}`,
    label: `${SCOPE_LABELS[scope]} ${PROPERTY_TYPE_LABELS[propertyType]}`,
    scope,
    propertyType,
  })),
)

export const Route = createFileRoute('/internal/system/configurator')({
  validateSearch: listSearchValidator(configuratorListFilters),
  component: ConfiguratorPage,
})

function ConfiguratorPage() {
  const filters = useListFilters(configuratorListFilters, Route)
  const { scope, propertyType } = filters.values

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Tabs
        layout="row"
        tabs={TREE_TABS}
        activeTab={`${scope}:${propertyType}`}
        onChange={id => {
          const tab = TREE_TABS.find(one => one.id === id)
          if (tab) {
            filters.setMany({
              scope: tab.scope,
              propertyType: tab.propertyType,
            })
          }
        }}
      />

      <ConfiguratorScreen
        scope={scope}
        propertyType={propertyType}
        filters={filters}
      />
    </div>
  )
}
